import { boardsApi } from '../../../api';
import type { Board, UpdateBoardInput } from '../../../types';
import type { BoardStateSetter } from '../types';
import { updateBoardInState } from '../utils';

export const createUpdateBoard = (set: BoardStateSetter) => {
  return async (id: string, input: UpdateBoardInput): Promise<Board> => {
    const updated = await boardsApi.update(id, input);
    set((state) => updateBoardInState(state, id, updated));
    return updated;
  };
};
